<div class="employee-navigation__wrapper">
    <div class="employee-navigation__list" (click)="onClose()">
        @for (employeeGroupName of employeeGroupNameList; track employeeGroupName) {
            <div
                priva-card
                [hasHeader]="false"
                [hasBody]="true"
                (click)="onNavigate(employeeGroupName)"
                class="employee-navigation__list--tile"
            >
                <ng-container
                    [ngTemplateOutlet]="groupIcon"
                    [ngTemplateOutletContext]="{ employeeGroupName }"
                />
            </div>
        }
        <div
            priva-card
            [hasHeader]="false"
            [hasBody]="true"
            (click)="onClose()"
            class="employee-navigation__list--tile employee-navigation__list--tile-close"
        >
            <i class="fas fa-solid fa-close"></i>
        </div>
    </div>
</div>

<ng-template #groupIcon let-employeeGroupName="employeeGroupName">
    @switch (employeeGroupName) {
        @case (promotedGroupName) {
            <i class="fas fa-clock"></i>
        }
        @default {
            {{ employeeGroupName }}
        }
    }
</ng-template>
